import { render, staticRenderFns } from "./correct2.vue?vue&type=template&id=bb4065ec&scoped=true"
import script from "./correct2.vue?vue&type=script&lang=js"
export * from "./correct2.vue?vue&type=script&lang=js"
import style0 from "./correct2.vue?vue&type=style&index=0&id=bb4065ec&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4065ec",
  null
  
)

export default component.exports